import { createContext } from "react";
import { AuthConfig } from "./config/authConfig";
import { keycloak, logout as oidcLogout, getAccessToken } from "../auth/oidc";

// Was a duplicate of oidc.ts's getAccessToken (same retry-before-login
// behavior now lives there once) — re-exported here so existing imports of
// getToken from this module keep working.
export const getToken = getAccessToken;

export const isLoggedIn = (): boolean => !!keycloak.authenticated;

export const logOut = (): void => {
  AuthConfig.setUserInfo(null);
  AuthConfig.setMyInfo(null);
  void oidcLogout();
};

export const UserContext = createContext({
  isLoggedIn: isLoggedIn,
  logOut: logOut,
});
